// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Слайдер */
.slick-slider {
  position: relative;
  min-width: 0;
}

/* Слайдер запущен */
/* Слайдер с точками */
/* Ограничивающая оболочка */
.slick-list {
  overflow: hidden;
}

/* Лента слайдов */
.slick-track {
  display: flex;
}

/* Слайд */
/* Слайд активный (показывается) */
/* Слайд основной */
/* Слайд по центру */
/* Клонированный слайд */
/* Стрелка */
.slick-arrow {
  position: absolute;
  top: 50%;
  z-index: 10;
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.1875rem;
  height: 2.1875rem;
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);
  border-radius: 0.1875rem;
  transition: background-color 0.3s ease 0s;
  transform: translateY(calc(-50% - 3.125rem));
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/50% no-repeat;
}
@media (max-width: 36.25em) {
  .slick-arrow {
    display: none;
  }
}
@media (any-hover: hover) {
  .slick-arrow:hover {
    background-color: #f6f6f6;
  }
}

/* Стрелка влево */
.slick-arrow.slick-prev {
  left: -3.75rem;
}

/* Стрелка вправо */
.slick-arrow.slick-next {
  right: -3.75rem;
  transform: translateY(calc(-50% - 2.5rem)) rotate(-180deg);
  box-shadow: 0px -6px 8px rgba(0, 0, 0, 0.2);
}

/* Стрелка не активная */
.slick-arrow.slick-disabled {
  opacity: 0.5;
}

/* Точки (булиты) */
.slick-dots {
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 1.875rem 0;
  gap: 0.9375rem;
}

/* Активная точка */
/* Элемент точки */
.slick-dots li button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background-color: #D9D9D9;
  transition: all 0.3s ease 0s;
  font-size: 0;
}

.slick-dots li.slick-active button {
  background-color: #119DA4;
}

.cards {
  margin: 0 auto;
}
@media (min-width: 36.25em) and (min-width: 48em) {
  .cards {
    padding-right: 7.5rem;
  }
}
@media (min-width: 36.25em) and (min-width: 36.25em) and (max-width: 48em) {
  @supports (padding-right: clamp( 3.125rem , -10.3723404255rem  +  37.2340425532vw , 7.5rem )) {
    .cards {
      padding-right: clamp( 3.125rem , -10.3723404255rem  +  37.2340425532vw , 7.5rem );
    }
  }
  @supports not (padding-right: clamp( 3.125rem , -10.3723404255rem  +  37.2340425532vw , 7.5rem )) {
    .cards {
      padding-right: calc(3.125rem + 4.375 * (100vw - 36.25rem) / 11.75);
    }
  }
}
@media (min-width: 36.25em) and (max-width: 36.25em) {
  .cards {
    padding-right: 3.125rem;
  }
}
@media (min-width: 36.25em) and (min-width: 48em) {
  .cards {
    padding-left: 7.5rem;
  }
}
@media (min-width: 36.25em) and (min-width: 36.25em) and (max-width: 48em) {
  @supports (padding-left: clamp( 3.125rem , -10.3723404255rem  +  37.2340425532vw , 7.5rem )) {
    .cards {
      padding-left: clamp( 3.125rem , -10.3723404255rem  +  37.2340425532vw , 7.5rem );
    }
  }
  @supports not (padding-left: clamp( 3.125rem , -10.3723404255rem  +  37.2340425532vw , 7.5rem )) {
    .cards {
      padding-left: calc(3.125rem + 4.375 * (100vw - 36.25rem) / 11.75);
    }
  }
}
@media (min-width: 36.25em) and (max-width: 36.25em) {
  .cards {
    padding-left: 3.125rem;
  }
}

.card {
  padding: 0 0.78125rem;
}
.cards-grid .card {
  padding: 0;
}
.card__content {
  border: 1px solid #D9D9D9;
  background-color: #fff;
}
.card__body {
  padding: 0.625rem;
}

.image-card {
  width: 100%;
  padding-bottom: 66.6666666667%;
}
.image-card__category {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #119DA4;
  color: #fff;
  padding: 0.4375rem;
  font-size: 0.75rem;
  letter-spacing: 0.035em;
  font-weight: 700;
}
.image-card__status {
  pointer-events: none;
  font-size: 0.75rem;
  position: absolute;
  top: 0.625rem;
  left: 0.625rem;
  background-color: #fff;
  color: #119DA4;
  padding: 0.4375rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0.25rem;
  font-weight: 600;
}
.image-card__status_finish {
  background-color: #119DA4;
  color: #fff;
}

.actions-card {
  padding-top: 1.25rem;
  display: flex;
  gap: 0.625rem;
}
.percent-card {
  margin: 2.5rem 0.3125rem 0 0.3125rem;
  height: 0.375rem;
  position: relative;
}
.percent-card__full {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #D9D9D9;
}
.percent-card__to {
  position: absolute;
  width: 90%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #119DA4;
  transition: all 0.3s ease 0s;
}
.percent-card__to::before {
  content: "";
  position: absolute;
  border-radius: 50%;
  width: 0.875rem;
  height: 0.875rem;
  background-color: #119DA4;
  transform: translate(0px, -4px);
  top: 0;
  right: -7px;
  border: 2px solid #fff;
}
.percent-card__prc {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.25rem 0.1875rem;
  border-radius: 0.3125rem;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
  top: -100%;
  right: 0;
  transform: translate(49%, -21px);
  background-color: #fff;
  font-size: 0.75rem;
}
.percent-card__prc::after {
  content: "";
  position: absolute;
  z-index: -1;
  width: 6px;
  height: 6px;
  background-color: #fff;
  bottom: -2px;
  left: 50%;
  transform: translate(-50%, 0px) rotate(-45deg);
}

.sum-card {
  padding-top: 1.25rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.625rem;
}
.sum-card__title {
  font-size: 0.75rem;
  letter-spacing: 0.035em;
  font-weight: 600;
}
.sum-card__title:not(:last-child) {
  margin-bottom: 0.9375rem;
}
.sum-card__sum {
  font-size: 0.875rem;
  letter-spacing: 0.035em;
  color: #119DA4;
}
.sum-card__raised {
  padding: 0 0.9375rem;
  border-left: 1px solid #D1D1D1;
  border-right: 1px solid #D1D1D1;
}
.sum-card__to-go {
  justify-self: end;
}

.date-project {
  padding-top: 1.25rem;
  font-size: 0.75rem;
  display: grid;
  gap: 0.9375rem;
}
.header-card {
  display: grid;
  gap: 0.625rem;
  letter-spacing: 0.035em;
}
.header-card__date {
  font-size: 0.625rem;
  color: #A8A8A8;
}
.header-card__title {
  font-size: 1rem;
  font-weight: 600;
}
.header-card__description {
  font-size: 0.8125rem;
  line-height: 1.5384615385;
  color: #787878;
}

.tags {
  padding: 1.25rem 0rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.625rem;
}
.tags__button {
  font-size: 0.75rem;
  display: flex;
  flex-direction: row-reverse;
}
.tags__button::before {
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/landing/swiper/swiper.scss","webpack://./src/assets/scss/variables.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB,YAAA;AAEA;EACC,kBAAA;EACA,YAAA;AAJD;;AAQA,oBAAA;AAGA,sBAAA;AAGA,4BAAA;AACA;EACC,gBAAA;AATD;;AAYA,kBAAA;AACA;EACC,aAAA;AATD;;AAaA,UAAA;AAGA,kCAAA;AAGA,mBAAA;AAGA,oBAAA;AAGA,wBAAA;AAGA,YAAA;AACA;EAKC,kBAAA;EACA,QAAA;EAEA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,wBAAA;EAEA,yCAAA;EACA,4CAAA;EACA,6EAAA;AA3BD;AAOC;EADD;IAEE,aAAA;EAJA;AACF;AAwBC;EACC;IACC,yBC9Da;EDwCd;AACF;;AA0BA,kBAAA;AACA;EACC,cAAA;AAvBD;;AA0BA,mBAAA;AACA;EACC,eAAA;EACA,0DAAA;EACA,2CAAA;AAvBD;;AA0BA,wBAAA;AACA;EACC,YAAA;AAvBD;;AA0BA,mBAAA;AACA;EACC,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAvBD;;AA4BA,mBAAA;AAIA,kBAAA;AACA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,4BAAA;EAEA,YAAA;AA7BD;;AAgCA;EACC,yBAAA;AA7BD;;AAuHA;EACC,cAAA;AApHD;AEVE;EF6HF;IE5HG,qBAAA;EFaD;AACF;AETC;EAGC;IFoHF;MEnHG,iFAnBc;IF6Bb;EACF;EEPA;IF+GF;ME9GG,kEAAA;IFUC;EACF;AACF;AEPE;EFyGF;IExGG,uBAAA;EFUD;AACF;AEhCE;EF6HF;IE5HG,oBAAA;EFmCD;AACF;AE/BC;EAGC;IFoHF;MEnHG,gFAnBc;IFmDb;EACF;EE7BA;IF+GF;ME9GG,iEAAA;IFgCC;EACF;AACF;AE7BE;EFyGF;IExGG,sBAAA;EFgCD;AACF;;AAmFA;EACC,qBAAA;AAhFD;AAkFC;EACC,UAAA;AAhFF;AAmFC;EACC,yBAAA;EACA,sBAAA;AAjFF;AAwFC;EACC,iBAAA;AAtFF;;AA0FA;EACC,WAAA;EACA,8BAAA;AAvFD;AA6FC;EAEC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,yBCvPa;EDwPb,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AA5FF;AAgGC;EACC,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,cCvQa;EDwQb,kBAAA;EACA,2CAAA;EACA,sBAAA;EACA,gBAAA;AA9FF;AAgGE;EACC,yBC9QY;ED+QZ,WAAA;AA9FH;;AAuHA;EACC,oBAAA;EACA,aAAA;EACA,aAAA;AApHD;AAmIA;EAEC,oCAAA;EACA,gBAAA;EACA,kBAAA;AAlID;AAqIC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;AAnIF;AAuIC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,yBCjVa;EDkVb,4BAAA;AArIF;AAuIE;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBC1VY;ED2VZ,+BAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AArIH;AAoJC;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,2CAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;AAlJF;AAsJE;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,8CAAA;AApJH;;AA4JA;EACC,oBAAA;EACA,aAAA;EACA,qCAAA;EAEA,aAAA;AA1JD;AAgKC;EACC,kBAAA;EACA,uBAAA;EACA,gBAAA;AA9JF;AAgKE;EACC,wBAAA;AA9JH;AAmKC;EACC,mBAAA;EACA,uBAAA;EACA,cCvaa;ADsQf;AAqKC;EACC,oBAAA;EACA,8BAAA;EACA,+BAAA;AAnKF;AAuKC;EACC,iBAAA;AArKF;;AAyKA;EACC,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAtKD;AA+KA;EACC,aAAA;EACA,aAAA;EACA,uBAAA;AA7KD;AAgLC;EACC,mBAAA;EACA,cCjdiB;ADmSnB;AAkLC;EACC,eAAA;EACA,gBAAA;AAhLF;AAoLC;EACC,oBAAA;EACA,yBAAA;EACA,cC/dqB;AD6SvB;;AAsLA;EACC,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AAnLD;AAsLC;EACC,kBAAA;EACA,aAAA;EACA,2BAAA;AApLF;AAsLE;EACC,eAAA;AApLH","sourcesContent":["@use 'sass:math';\r\n@import '../../../assets/scss/variable-settings.scss';\r\n@import '../../../assets/scss/mixins.scss';\r\n@import '../../../assets/scss/variables.scss';\r\n\r\n/* Слайдер */\r\n\r\n.slick-slider {\r\n\tposition: relative;\r\n\tmin-width: 0;\r\n}\r\n\r\n\r\n/* Слайдер запущен */\r\n.slick-slider.slick-initialized {}\r\n\r\n/* Слайдер с точками */\r\n.slick-slider.slick-dotted {}\r\n\r\n/* Ограничивающая оболочка */\r\n.slick-list {\r\n\toverflow: hidden;\r\n}\r\n\r\n/* Лента слайдов */\r\n.slick-track {\r\n\tdisplay: flex;\r\n\t// align-items: flex-start;\r\n}\r\n\r\n/* Слайд */\r\n.slick-slide {}\r\n\r\n/* Слайд активный (показывается) */\r\n.slick-slide.slick-active {}\r\n\r\n/* Слайд основной */\r\n.slick-slide.slick-current {}\r\n\r\n/* Слайд по центру */\r\n.slick-slide.slick-center {}\r\n\r\n/* Клонированный слайд */\r\n.slick-slide.slick-cloned {}\r\n\r\n/* Стрелка */\r\n.slick-arrow {\r\n\t@media (max-width: em(580)) {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\t// transform: translate(0px, -50%);\r\n\tz-index: 10;\r\n\tfont-size: 0;\r\n\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\twidth: rem(35);\r\n\theight: rem(35);\r\n\tbox-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);\r\n\tborder-radius: rem(3);\r\n\t// background-color: #fff;\r\n\ttransition: background-color 0.3s ease 0s;\r\n\ttransform: translateY(calc(-50% - rem(50)));\r\n\tbackground: #fff url('../../../assets/images/arrow.svg') center / 50% no-repeat;\r\n\r\n\t@media (any-hover: hover) {\r\n\t\t&:hover {\r\n\t\t\tbackground-color: $mainLightGrey;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n/* Стрелка влево */\r\n.slick-arrow.slick-prev {\r\n\tleft: rem(-60);\r\n}\r\n\r\n/* Стрелка вправо */\r\n.slick-arrow.slick-next {\r\n\tright: rem(-60);\r\n\ttransform: translateY(calc(-50% - rem(40))) rotate(-180deg);\r\n\tbox-shadow: 0px -6px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Стрелка не активная */\r\n.slick-arrow.slick-disabled {\r\n\topacity: 0.5;\r\n}\r\n\r\n/* Точки (булиты) */\r\n.slick-dots {\r\n\tdisplay: flex !important;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tpadding: rem(30) 0;\r\n\tgap: rem(15);\r\n}\r\n\r\n.slick-dots li {}\r\n\r\n/* Активная точка */\r\n.slick-dots li.slick-active {}\r\n\r\n\r\n/* Элемент точки */\r\n.slick-dots li button {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\twidth: rem(10);\r\n\theight: rem(10);\r\n\tborder-radius: 50%;\r\n\tbackground-color: #D9D9D9;\r\n\ttransition: all 0.3s ease 0s;\r\n\r\n\tfont-size: 0;\r\n}\r\n\r\n.slick-dots li.slick-active button {\r\n\tbackground-color: #119DA4;\r\n}\r\n\r\n//========================================================================================================================================================\r\n\r\n// .custom-dots-container {\r\n// \tdisplay: flex;\r\n// \tjustify-content: center;\r\n// \talign-items: center;\r\n// \tpadding: rem(30) 0;\r\n// \tgap: rem(15);\r\n// }\r\n\r\n// .dot {\r\n// \tdisplay: flex;\r\n// \tjustify-content: center;\r\n// \talign-items: center;\r\n// \twidth: rem(10);\r\n// \theight: rem(10);\r\n// \tborder-radius: 50%;\r\n// \tbackground-color: #D9D9D9;\r\n// \ttransition: all 0.3s ease 0s;\r\n\r\n// \t&.active {\r\n// \t\tbackground-color: #119DA4;\r\n// \t}\r\n// }\r\n\r\n// .slide-control,\r\n// .slide-control-project {\r\n// \t@media (max-width: em(580)) {\r\n// \t\tdisplay: none;\r\n// \t}\r\n\r\n// \tposition: absolute;\r\n// \twidth: 100%;\r\n// \theight: rem(35);\r\n// \ttop: 50%;\r\n// \tleft: 0;\r\n// \ttransform: translate(0px, -50%);\r\n\r\n// \t// .slide-control__button\r\n// \t&__button {\r\n// \t\tcursor: pointer;\r\n// \t\tposition: absolute;\r\n// \t\ttop: 50%;\r\n// \t\t// z-index: 40;\r\n// \t\tdisplay: flex;\r\n// \t\tjustify-content: center;\r\n// \t\talign-items: center;\r\n// \t\twidth: rem(35);\r\n// \t\theight: rem(35);\r\n// \t\tbox-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);\r\n// \t\tborder-radius: rem(3);\r\n// \t\tbackground-color: #fff;\r\n// \t\ttransition: background-color 0.3s ease 0s;\r\n// \t\ttransform: translateY(calc(-50% - rem(50)));\r\n\r\n// \t\t@media (any-hover: hover) {\r\n// \t\t\t&:hover {\r\n// \t\t\t\tbackground-color: $mainLightGrey;\r\n// \t\t\t}\r\n// \t\t}\r\n\r\n// \t\tsvg {\r\n// \t\t\tpointer-events: none\r\n// \t\t}\r\n\r\n// \t\t// .slide-control__button_next\r\n// \t\t&_next {\r\n// \t\t\t// right: rem(60);\r\n// \t\t\t// @include adaptiveValue(\"right\", 60, 15, 0, 992, 580);\r\n// \t\t\tright: rem(-60);\r\n\r\n// \t\t\tsvg {\r\n// \t\t\t\ttransform: rotate(-180deg);\r\n// \t\t\t}\r\n// \t\t}\r\n\r\n// \t\t// .slide-control__button_prev\r\n// \t\t&_prev {\r\n// \t\t\t// left: rem(60);\r\n// \t\t\t// @include adaptiveValue(\"left\", 60, 15, 0, 992, 580);\r\n// \t\t\tleft: rem(-60);\r\n// \t\t}\r\n// \t}\r\n// }\r\n\r\n//========================================================================================================================================================\r\n\r\n.cards {\r\n\tmargin: 0 auto;\r\n\t// padding-bottom: rem(30);\r\n\r\n\t// max-width: rem(1010);\r\n\t// padding: 0 rem(120);\r\n\t@media (min-width:em(580)) {\r\n\t\t@include adaptiveValue(\"padding-right\", 120, 50, 0, 768, 580);\r\n\t\t@include adaptiveValue(\"padding-left\", 120, 50, 0, 768, 580);\r\n\t}\r\n}\r\n\r\n.card {\r\n\tpadding: 0 rem(12.5);\r\n\r\n\t.cards-grid & {\r\n\t\tpadding: 0;\r\n\t}\r\n\r\n\t&__content {\r\n\t\tborder: 1px solid #D9D9D9;\r\n\t\tbackground-color: #fff;\r\n\t}\r\n\r\n\t// .card-news__image-ibg\r\n\t&__image-ibg {}\r\n\r\n\t// .card-news__body\r\n\t&__body {\r\n\t\tpadding: rem(10);\r\n\t}\r\n}\r\n\r\n.image-card {\r\n\twidth: 100%;\r\n\tpadding-bottom: percent(200, 300);\r\n\r\n\t// .image-card__img\r\n\t&__img {}\r\n\r\n\t// .image-card__category\r\n\t&__category {\r\n\t\t// pointer-events: none;\r\n\t\tposition: absolute;\r\n\t\tbottom: 0;\r\n\t\tleft: 0;\r\n\t\tbackground-color: $mainDarkCyan;\r\n\t\tcolor: #fff;\r\n\t\tpadding: rem(7);\r\n\t\tfont-size: rem(12);\r\n\t\tletter-spacing: 0.035em;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\r\n\t// .image-card__status\r\n\t&__status {\r\n\t\tpointer-events: none;\r\n\t\tfont-size: rem(12);\r\n\t\tposition: absolute;\r\n\t\ttop: rem(10);\r\n\t\tleft: rem(10);\r\n\t\tbackground-color: #fff;\r\n\t\tcolor: $mainDarkCyan;\r\n\t\tpadding: rem(7);\r\n\t\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n\t\tborder-radius: rem(4);\r\n\t\tfont-weight: 600;\r\n\r\n\t\t&_finish {\r\n\t\t\tbackground-color: $mainDarkCyan;\r\n\t\t\tcolor: #fff;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.body-card {\r\n\r\n\t// .body-card__header\r\n\t&__header {}\r\n\r\n\t// .body-card__tags\r\n\t&__tags {}\r\n\r\n\t// .body-card__button\r\n\t&__button {}\r\n\r\n\t// .body-card__actions\r\n\t&__actions {}\r\n\r\n\t// .body-card__footer\r\n\t&__footer {}\r\n\r\n\r\n}\r\n\r\n.actions-card {\r\n\tpadding-top: rem(20);\r\n\tdisplay: flex;\r\n\tgap: rem(10);\r\n\r\n\t// .actions-card__button\r\n\t&__button {}\r\n}\r\n\r\n.card-footer {\r\n\r\n\t// .card-footer__percent\r\n\t&__percent {}\r\n\r\n\t// .card-footer__sum\r\n\t&__sum {}\r\n}\r\n\r\n.percent-card {\r\n\r\n\tmargin: rem(40) rem(5) 0 rem(5);\r\n\theight: rem(6);\r\n\tposition: relative;\r\n\r\n\t// .percent-card__full\r\n\t&__full {\r\n\t\tposition: absolute;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tbackground-color: #D9D9D9;\r\n\t}\r\n\r\n\t// .percent-card__to\r\n\t&__to {\r\n\t\tposition: absolute;\r\n\t\twidth: 90%;\r\n\t\theight: 100%;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tbackground-color: $mainDarkCyan;\r\n\t\ttransition: all 0.3s ease 0s;\r\n\r\n\t\t&::before {\r\n\t\t\tcontent: '';\r\n\t\t\tposition: absolute;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\twidth: rem(14);\r\n\t\t\theight: rem(14);\r\n\t\t\tbackground-color: $mainDarkCyan;\r\n\t\t\ttransform: translate(0px, -4px);\r\n\t\t\ttop: 0;\r\n\t\t\tright: -7px;\r\n\t\t\tborder: 2px solid #fff;\r\n\t\t\t// display: none;\r\n\t\t}\r\n\r\n\t\t// @media (any-hover: hover) {\r\n\t\t// \t&:hover {\r\n\t\t// \t\t.percent-card__prc {\r\n\t\t// \t\t\topacity: 1;\r\n\t\t// \t\t}\r\n\r\n\t\t// \t}\r\n\t\t// }\r\n\t}\r\n\r\n\t// .percent-card__prc\r\n\t&__prc {\r\n\t\tposition: absolute;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tpadding: rem(4) rem(3);\r\n\t\tborder-radius: rem(5);\r\n\t\tbox-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);\r\n\t\ttop: -100%;\r\n\t\tright: 0;\r\n\t\ttransform: translate(49%, -21px);\r\n\t\tbackground-color: #fff;\r\n\t\tfont-size: rem(12);\r\n\t\t// opacity: 0;\r\n\t\t// transition: all 0.3s ease 0s;\r\n\r\n\t\t&::after {\r\n\t\t\tcontent: '';\r\n\t\t\tposition: absolute;\r\n\t\t\tz-index: -1;\r\n\t\t\twidth: 6px;\r\n\t\t\theight: 6px;\r\n\t\t\tbackground-color: #fff;\r\n\t\t\tbottom: -2px;\r\n\t\t\tleft: 50%;\r\n\t\t\ttransform: translate(-50%, 0px) rotate(-45deg);\r\n\t\t}\r\n\r\n\r\n\t}\r\n\r\n}\r\n\r\n.sum-card {\r\n\tpadding-top: rem(20);\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(3, 1fr);\r\n\t// justify-content: space-between;\r\n\tgap: rem(10);\r\n\r\n\t// .sum-card__goals\r\n\t&__goals {}\r\n\r\n\t// .sum-card__title\r\n\t&__title {\r\n\t\tfont-size: rem(12);\r\n\t\tletter-spacing: 0.035em;\r\n\t\tfont-weight: 600;\r\n\r\n\t\t&:not(:last-child) {\r\n\t\t\tmargin-bottom: rem(15);\r\n\t\t}\r\n\t}\r\n\r\n\t// .sum-card__sum\r\n\t&__sum {\r\n\t\tfont-size: rem(14);\r\n\t\tletter-spacing: 0.035em;\r\n\t\tcolor: $mainDarkCyan;\r\n\t}\r\n\r\n\t// .sum-card__raised\r\n\t&__raised {\r\n\t\tpadding: 0 rem(15);\r\n\t\tborder-left: 1px solid #D1D1D1;\r\n\t\tborder-right: 1px solid #D1D1D1;\r\n\t}\r\n\r\n\t// .sum-card__to-go\r\n\t&__to-go {\r\n\t\tjustify-self: end;\r\n\t}\r\n}\r\n\r\n.date-project {\r\n\tpadding-top: rem(20);\r\n\tfont-size: rem(12);\r\n\tdisplay: grid;\r\n\tgap: rem(15);\r\n\r\n\t// .date-project__start\r\n\t&__start {}\r\n\r\n\t// .date-project__end\r\n\t&__end {}\r\n}\r\n\r\n.header-card {\r\n\tdisplay: grid;\r\n\tgap: rem(10);\r\n\tletter-spacing: 0.035em;\r\n\r\n\t// .header-card__date\r\n\t&__date {\r\n\t\tfont-size: rem(10);\r\n\t\tcolor: $mainCardDateGrey;\r\n\t}\r\n\r\n\t// .header-card__title\r\n\t&__title {\r\n\t\tfont-size: rem(16);\r\n\t\tfont-weight: 600;\r\n\t}\r\n\r\n\t// .header-card__description\r\n\t&__description {\r\n\t\tfont-size: rem(13);\r\n\t\tline-height: math.div(20, 13);\r\n\t\tcolor: $mainCardTextDarkGrey;\r\n\t}\r\n}\r\n\r\n.tags {\r\n\tpadding: rem(20) rem(0);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tflex-wrap: wrap;\r\n\tgap: rem(10);\r\n\r\n\t// .tags__button\r\n\t&__button {\r\n\t\tfont-size: rem(12);\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: row-reverse;\r\n\r\n\t\t&::before {\r\n\t\t\tfont-size: rem(16);\r\n\t\t}\r\n\t}\r\n}","$mainBrandColor: #007587;\r\n$mainBgGrey: #F0F8F2;\r\n$mainHoverButtonColor: #EDF5F6;\r\n$mainDarkGreen: #003300;\r\n$mainLightBlue: #92DCE5;\r\n\r\n$mainCardTextDarkGrey: #787878;\r\n$mainCardDateGrey: #A8A8A8;\r\n$mainCardTagDarkGrey: #6A6A6A;\r\n$mainLightGrey: #f6f6f6;\r\n$mainCardButtonDark: #383D3B;\r\n$mainSubtitleDarkGrey: #A9A9A9;\r\n$mainDarkCyan: #119DA4;\r\n$mainDarkenDarkCyan: #0082ca;","//Підключення шрифту\r\n@use \"sass:math\";\r\n\r\n@mixin font($font_name, $file_name, $weight, $style) {\r\n\t@font-face {\r\n\t\tfont-family: $font_name;\r\n\t\tfont-display: swap;\r\n\t\tsrc: url(\"../fonts/#{$file_name}.woff2\") format(\"woff2\"),\r\n\t\turl(\"../fonts/#{$file_name}.woff\") format(\"woff\");\r\n\t\tfont-weight: #{$weight};\r\n\t\tfont-style: #{$style};\r\n\t}\r\n}\r\n\r\n//Percent\r\n@function percent($px, $from) {\r\n\t$result: math.div($px, $from) * 100%;\r\n\t@return $result;\r\n}\r\n\r\n//REM\r\n@function rem($px) {\r\n\t$result: math.div($px, 16)+rem;\r\n\t@return $result;\r\n}\r\n\r\n//EM\r\n@function em($px, $current: 16) {\r\n\t$result: math.div($px, $current)+em;\r\n\t@return $result;\r\n}\r\n\r\n//Currency\r\n@mixin currency($sym) {\r\n\t&::after {\r\n\t\tcontent: \"#{$sym}\";\r\n\t}\r\n}\r\n\r\n// Grids\r\n@mixin gridCards($type: fit, $min: 280px, $max: 1fr, $gap: 30px) {\r\n\tdisplay: grid;\r\n\tgap: $gap;\r\n\tgrid-template-columns: repeat(auto-#{$type}, minmax($min, $max));\r\n}\r\n\r\n// Адаптивна властивість (clamp)\r\n@mixin adaptiveValue($property, $startSize, $minSize, $keepSize: 0, $widthFrom: $containerWidth, $widthTo: $minWidth) {\r\n\t@if ($startSize==0) {\r\n\t\t$startSize: 0.000001;\r\n\t}\r\n\r\n\t@if ($minSize==0) {\r\n\t\t$minSize: 0.000001;\r\n\t}\r\n\r\n\t// Для calc();\r\n\t$addSize: math.div($startSize - $minSize, 16);\r\n\r\n\t@if ($widthFrom ==$containerWidth and $maxWidthContainer ==0) {\r\n\t\t$widthFrom: $maxWidth;\r\n\t}\r\n\r\n\t// Брейк-поїнти в EM\r\n\t$widthFromMedia: em($widthFrom);\r\n\t$widthToMedia: em($widthTo);\r\n\r\n\t// Формула плаваючого значення\r\n\t// Источник: https://css-tricks.com/linearly-scale-font-size-with-css-clamp-based-on-the-viewport/\r\n\t$slope: math.div(($startSize - $minSize), ($widthFrom - $widthTo));\r\n\t$yIntersection: -$widthTo * $slope + $minSize;\r\n\r\n\t@if ($yIntersection==0) {\r\n\t\t$yIntersection: 0.000001;\r\n\t}\r\n\r\n\t$flyValue: #{rem($yIntersection)}\" + \"#{$slope * 100}vw;\r\n\r\n\t// Отримання значення властивості\r\n\t$propertyValue: #{\"clamp(\" rem($minSize) \",\" $flyValue \",\" rem($startSize) \")\"};\r\n\r\n\t// Якщо негативні значення\r\n\t@if ($minSize > $startSize) {\r\n\t\t$propertyValue: #{\"clamp(\" rem($startSize) \",\" $flyValue \",\" rem($minSize) \")\"};\r\n\t}\r\n\r\n\t// Встановлюємо значення за замовчуванням\r\n\t@if $keepSize  !=1 and $keepSize  !=3 {\r\n\t\t@media (min-width: $widthFromMedia) {\r\n\t\t\t#{$property}: rem($startSize);\r\n\t\t}\r\n\t}\r\n\r\n\t// Адаптуємо розмір у проміжку між зазначеними ширинами в'юпорту\r\n\t@media (min-width: $widthToMedia) and (max-width: $widthFromMedia) {\r\n\r\n\t\t// Якщо підтримується clamp();\r\n\t\t@supports (#{$property}: $propertyValue) {\r\n\t\t\t#{$property}: $propertyValue;\r\n\t\t}\r\n\r\n\t\t// Якщо не підтримується clamp();\r\n\t\t@supports not (#{$property}: $propertyValue) {\r\n\t\t\t#{$property}: calc(#{rem($minSize)} + #{$addSize} * (100vw - #{rem($widthTo)}) / #{math.div($widthFrom, 16) - math.div($widthTo, 16)});\r\n\t\t}\r\n\t}\r\n\r\n\t@if $keepSize  !=1 and $keepSize  !=2 {\r\n\t\t@media (max-width: $widthToMedia) {\r\n\t\t\t#{$property}: rem($minSize);\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
